exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.notfound-container[data-v-4bf244c8] {\n  text-align: center;\n  height: 100%;\n}\n.notfound-img[data-v-4bf244c8] {\n  display: block;\n  margin: 0 auto;\n  height: 80%;\n}\n.notfound-tips[data-v-4bf244c8] {\n  font-size: 26px;\n  color: #ccc;\n  font-style: italic;\n  font-family: cursive;\n}\n", ""]);

// exports
